module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag12_0548AT.bf04a19c.jpg";